// The default React import is what jest's classic JSX transform needs at runtime; the app's
// automatic-runtime typecheck reports it unused.
import React from 'react';
import { BiPlus, BiQr } from 'react-icons/bi';

import { REQUEST_RIDE_ACTION_KEY } from '@hopdrive/feature-portal-products';
import type { ProductActionsDefinition } from '@features/products/actions/types';

import GuestLinkModal from './components/GuestLinkModal';
import GuestRideModal from './components/GuestRideModal';

export interface GuestRidesActionFacts {
  /** The rooftop's guest self-service portal is enabled, so a shareable code exists. */
  guestPortalEnabled: boolean;
  /** The rooftop the shared code is generated for. */
  rooftop: { id?: number; name?: string | null } | null | undefined;
}

/**
 * Guest Rides' header actions: Request Ride as the one creation method (the layout gates it on
 * the entry's `canCreate`), and Share Code as the secondary when the rooftop's guest portal is
 * enabled. Both open dialogs the layout mounts at product level.
 */
export function resolveGuestRidesActions({
  guestPortalEnabled,
  rooftop,
}: GuestRidesActionFacts): ProductActionsDefinition {
  const definition: ProductActionsDefinition = {
    createUnavailableText: 'Requesting rides is unavailable for this rooftop — contact your account manager',
    creation: [
      {
        key: REQUEST_RIDE_ACTION_KEY,
        label: 'Request Ride',
        icon: <BiPlus />,
        dialog: ({ open, onClose }) => <GuestRideModal open={open} onClose={onClose} />,
      },
    ],
  };
  if (guestPortalEnabled) {
    definition.secondary = {
      key: 'share-code',
      label: 'Share Code',
      icon: <BiQr />,
      dialog: ({ open, onClose }) => (
        <GuestLinkModal
          open={open}
          onClose={onClose}
          entityId={rooftop?.id}
          entityType='customer'
          templateType='guestride.code.shared'
          rooftopName={rooftop?.name ?? undefined}
        />
      ),
    };
  }
  return definition;
}
